module.exports = __webpack_public_path__ + "img/ru_Ecran 2.679042bf.png";